import { graphql, readInlineData } from "react-relay";

import { checkIsMorningStudioArticle } from "~/components/article/article-render/morning-studio-article/helpers";
import { checkIsPhotoEssayArticle } from "~/components/article/article-render/photo-essay-article/helpers";
import { checkIsPostiesArticle } from "~/components/article/article-render/posties/helpers";
import type { helpersAppBarThemeArticle$key } from "~/queries/__generated__/helpersAppBarThemeArticle.graphql";

export type AppBarTheme = "light" | "dark" | "posties";

export const getAppBarTheme = (reference: helpersAppBarThemeArticle$key): AppBarTheme => {
  const article = readInlineData(
    graphql`
      fragment helpersAppBarThemeArticle on Base @inline {
        ...helpersArticleSections
        ...helpersCheckIsMorningStudioArticle
        ...helpersCheckIsPhotoEssayArticle
      }
    `,
    reference,
  );
  if (checkIsPostiesArticle(article)) {
    return "posties";
  }

  if (checkIsMorningStudioArticle(article) || checkIsPhotoEssayArticle(article)) {
    return "dark";
  }

  return "light";
};
